<script setup>
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';
import Trans from '@/i18n/translation';
import RoundedCheckIcon from '@/components/CustomIcons/RoundedCheckIcon.vue';
import resolveImgUrl from '@/services/resolveImageUrl';
import { Vue3Marquee } from 'vue3-marquee';

const i18n = useI18n();
const { locale } = useI18n();

const heroImg1 = resolveImgUrl('landing_Cyber_Main_card.png', locale.value);

const heroImg2 = resolveImgUrl('landing_hero_img_2.png', locale.value);

const heroImg3 = resolveImgUrl('landing_hero_img_3.png', locale.value);

const getStartedNavigation = Trans.i18nRoute({ name: 'register' });

const stats = [
  { id: 1, name: i18n.t('landingPage.heroSection.stats[0]'), value: RoundedCheckIcon },
  { id: 2, name: i18n.t('landingPage.heroSection.stats[1]'), value: RoundedCheckIcon },
  { id: 3, name: i18n.t('landingPage.heroSection.stats[2]'), value: RoundedCheckIcon },
];
</script>

<template>
  <div class="gradient-with-mesh text-primary pb-24 after:absolute after:bottom-0 after:w-full after:h-[3px] after:bg-highlightLight">
    <div class="relative isolate overflow-hidden">
      <div class="mx-auto max-w-7xl px-6 pb-4 pt-10 sm:pb-4 lg:flex lg:px-8 lg:pt-40">
        <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-lg lg:flex-shrink-0">
          <i18n-t
            tag="h1"
            class="leading-10 font-bold text-6xl text-highlight text-center lg:text-left"
            keypath="landingPage.heroSection.slogan"
            for="highlighted"
          >
            <span class="text-secondary">{{
              $t('landingPage.heroSection.sloganHighlighted')
            }}</span>
          </i18n-t>
          <p class="mt-8 text-md leading-8 text-center lg:text-left">
            {{ $t('landingPage.heroSection.subtext') }}
          </p>
          <div class="mt-14 items-center gap-x-6">
            <RouterLink
              :to="getStartedNavigation"
              class="btn-cta w-full block text-center text-lg py-4"
            >
              {{ $t('getStartedCTA') }}
            </RouterLink>
          </div>
        </div>
        <div
          class="mx-auto mt-16 flex flex-grow justify-center max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0
          lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32"
        >
          <div class="">
            <div class="flex flex-row gap-x-6 justify-center">
              <div class="rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4  sm:block">
                <img
                    :src="heroImg1"
                    class="rounded-md shadow-2xl w-48 md:w-56 lg:w-80 object-contain"
                    alt="Cyberalarm hero image"
                >
              </div>

              <div class="rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4">
                <img
                    :src="heroImg3"
                    class="rounded-md shadow-2xl w-48  md:w-56 lg:w-80 object-contain"
                    alt="Cyberalarm timed choice"
                >
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="mx-auto w-full py-6  text-primary lg:px-8 base-gradient ">
    <div class="mx-auto max-w-7xl">
      <dl
        class="text-center overflow-hidden rounded-2xl"
      >
        <div class="sm:block lg:hidden w-full overflow-hidden">
          <div class="flex flex-col px-2 py-8 col-span-1 items-center justify-center">
            <h2 class="text-2xl font-semibold mb-3 text-center">
              {{ $t('landingPage.heroSection.statsTitle') }}
            </h2>
            <RouterLink
                :to="Trans.i18nRoute({ name: 'home', hash: '#how-it-works' })"
                class="btn-transparent max-w-3xl"
            >
              {{ $t('landingPage.seeMore') }}
            </RouterLink>
          </div>
          <div class="flex flex-col   col-span-1 items-center justify-center">
            <Vue3Marquee
              :clone="true"
              :duration="10"
            >
              <div
                v-for="stat in stats"
                :key="stat.id"
                class="flex flex-col items-center justify-center min-w-[200px] px-6 py-4"
              >
                <dd class="text-3xl mb-2 flex justify-center items-center">
                  <component :is="stat.value" />
                </dd>
                <dt class="text-md leading-6 text-center">
                  {{ stat.name }}
                </dt>
              </div>
            </Vue3Marquee>
          </div>
        </div>
        <div class="hidden lg:grid grid-cols-4 gap-1">
          <div class="flex flex-col p-8 col-span-1">
            <h2 class="text-xl font-semibold mb-3 text-left">
              {{ $t('landingPage.heroSection.statsTitle') }}
            </h2>
            <RouterLink
                :to="Trans.i18nRoute({ name: 'home', hash: '#how-it-works' })"
                class="btn-transparent"
            >
              {{ $t('landingPage.seeMore') }}
            </RouterLink>
          </div>
          <div
            v-for="stat in stats"
            :key="stat.id"
            class="flex flex-col p-6 gap-2 justify-center items-center"
          >
            <dd class="text-3xl mb-2 flex justify-center items-center">
              <component :is="stat.value" />
            </dd>
            <dt class="text-md leading-6 text-center">
              {{ stat.name }}
            </dt>
          </div>
        </div>
      </dl>
    </div>
  </div>
</template>